import React from "react";
import clsx from "clsx";

import styles from "./layout.module.scss";

type StripedRowProps = {
	className?: string;
	style?: React.CSSProperties;
	content?: React.ReactNode | JSX.Element;
};

export const StripedRow = ({ className, content, style }: StripedRowProps) => {
	return (
		<li className={clsx(styles.stripedRow, className)} style={{ ...style }}>
			{content}
		</li>
	);
};
